// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1W9eO","row":"ProcedureTreatmentSummary_row__3pqGE"};